import Global from "../utils/Global";
import ApiClient from "./ApiClient";

export const fetchReferrals = async ({ token, page, filterBy, searchQuery, pageSize }) => {
    return await ApiClient.get('/api/referrals', {
        params: {
            search_query: searchQuery,
            page,
            page_size: pageSize,
            filter_by: filterBy,
        },
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export const addReferral = ({ token, referral }) => {
    return ApiClient.post('/api/referrals', referral, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export const updateReferral = ({ token, referral, referralId }) => {
    return ApiClient.put('/api/referrals/' + referralId, referral, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export const deleteReferral = ({ token, referralId }) => {
    return ApiClient.delete('/api/referrals/' + referralId, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export const exportReferrals = async ({ token, filters }) => {
    try {
        const queryString = new URLSearchParams(filters).toString();
        const response = await fetch(Global.baseURL + `/api/referrals/export?${queryString}`, {
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + token
            }
        });

        if (!response.ok) {
            throw new Error('Failed to export referrals');
        }

        return response.blob();
    } catch (error) {
        // Handle error
        console.error('Error exporting referrals:', error);
        throw error;
    }
}